// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;800;900&family=Playfair+Display:ital@0;1&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: auto;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  padding: 0;
  width: 100%;
}

.register-box {
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
  width: 100%;
  max-width: 100%;
  animation: none;
}

.register-header {
  text-align: center;
  margin-bottom: 20px;
}

.register-title {
  font-family: 'Orbitron', sans-serif;
  font-size: 26px;
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 2px;
  margin: 0 0 8px 0;
  text-transform: uppercase;
  font-style: italic;
}

.register-subtitle {
  color: #666;
  font-size: 13px;
  margin: 0;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-label {
  font-weight: 600;
  color: #333;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-input {
  padding: 10px 12px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  transition: all 0.3s ease;
  background: #f9f9f9;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input:disabled {
  background: #f0f0f0;
  cursor: not-allowed;
  opacity: 0.6;
}

.error-message {
  background: #fee;
  color: #c33;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 11px;
  border-left: 4px solid #c33;
  animation: shake 0.3s ease-in-out;
  margin-top: 3px;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

.register-button {
  padding: 10px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 6px;
}

.register-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
}

.register-button:active:not(:disabled) {
  transform: translateY(0);
}

.register-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.register-footer {
  text-align: center;
  margin-top: 15px;
  padding-top: 12px;
  border-top: 1px solid #eee;
}

.footer-text {
  color: #666;
  font-size: 13px;
  margin: 0;
  letter-spacing: 0.5px;
}

.toggle-form-btn {
  background: none;
  border: none;
  color: #667eea;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  font-size: 13px;
  padding: 0;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.toggle-form-btn:hover:not(:disabled) {
  color: #764ba2;
  text-decoration: underline;
}

.toggle-form-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .register-title {
    font-size: 24px;
    letter-spacing: 1.5px;
  }

  .register-button {
    padding: 11px 16px;
    font-size: 13px;
  }

  .form-input {
    padding: 11px 12px;
    font-size: 12px;
  }

  .form-label {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .register-title {
    font-size: 20px;
    letter-spacing: 1px;
  }

  .register-subtitle {
    font-size: 12px;
  }

  .register-form {
    gap: 12px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .form-input {
    padding: 10px 12px;
    font-size: 12px;
  }

  .form-label {
    font-size: 11px;
  }

  .register-button {
    padding: 10px 14px;
    font-size: 12px;
  }

  .footer-text {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Register.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;800;900&family=Playfair+Display:ital@0;1&display=swap');\n\n.register-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: auto;\n  background: transparent;\n  font-family: 'Poppins', sans-serif;\n  padding: 0;\n  width: 100%;\n}\n\n.register-box {\n  background: transparent;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  animation: none;\n}\n\n.register-header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.register-title {\n  font-family: 'Orbitron', sans-serif;\n  font-size: 26px;\n  font-weight: 800;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: 2px;\n  margin: 0 0 8px 0;\n  text-transform: uppercase;\n  font-style: italic;\n}\n\n.register-subtitle {\n  color: #666;\n  font-size: 13px;\n  margin: 0;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.register-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-label {\n  font-weight: 600;\n  color: #333;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-input {\n  padding: 10px 12px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 12px;\n  font-family: 'Poppins', sans-serif;\n  transition: all 0.3s ease;\n  background: #f9f9f9;\n}\n\n.form-input:focus {\n  outline: none;\n  border-color: #667eea;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-input:disabled {\n  background: #f0f0f0;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.error-message {\n  background: #fee;\n  color: #c33;\n  padding: 10px 12px;\n  border-radius: 8px;\n  font-size: 11px;\n  border-left: 4px solid #c33;\n  animation: shake 0.3s ease-in-out;\n  margin-top: 3px;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-5px); }\n  75% { transform: translateX(5px); }\n}\n\n.register-button {\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-top: 6px;\n}\n\n.register-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);\n}\n\n.register-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.register-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.register-footer {\n  text-align: center;\n  margin-top: 15px;\n  padding-top: 12px;\n  border-top: 1px solid #eee;\n}\n\n.footer-text {\n  color: #666;\n  font-size: 13px;\n  margin: 0;\n  letter-spacing: 0.5px;\n}\n\n.toggle-form-btn {\n  background: none;\n  border: none;\n  color: #667eea;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  font-size: 13px;\n  padding: 0;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.toggle-form-btn:hover:not(:disabled) {\n  color: #764ba2;\n  text-decoration: underline;\n}\n\n.toggle-form-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .register-title {\n    font-size: 24px;\n    letter-spacing: 1.5px;\n  }\n\n  .register-button {\n    padding: 11px 16px;\n    font-size: 13px;\n  }\n\n  .form-input {\n    padding: 11px 12px;\n    font-size: 12px;\n  }\n\n  .form-label {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .register-title {\n    font-size: 20px;\n    letter-spacing: 1px;\n  }\n\n  .register-subtitle {\n    font-size: 12px;\n  }\n\n  .register-form {\n    gap: 12px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 10px;\n  }\n\n  .form-input {\n    padding: 10px 12px;\n    font-size: 12px;\n  }\n\n  .form-label {\n    font-size: 11px;\n  }\n\n  .register-button {\n    padding: 10px 14px;\n    font-size: 12px;\n  }\n\n  .footer-text {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
